import PackagingInterestChartPanel from "./packagingInterestChartPanel.container";

export default PackagingInterestChartPanel;
